import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import AuthStateProvider from "./stores/Global";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { setupInterceptors } from "./services/interceptors";

const root = createRoot(document.getElementById("root") as HTMLElement);

setupInterceptors();

const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <AuthStateProvider>
      <App />
    </AuthStateProvider>
  </QueryClientProvider>
);
